import BaseComponent from "../../baseComponent.js";
import IdentityAccessService from "../../../core/services/identityAccessService.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import styles from "./styles.scss";

const accountType = "2";

export default class AccountSettings extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      userEmail: "",
      Error: ""
    }
  }

  componentDidMount() {
    $(this.refs.container).find("select").material_select();
    let user = IdentityAccessService.getUserProfile();
    this.setState({firstName: user.firstName, lastName: user.lastName, userEmail: user.email});
    this.publish(InternalEvent.App.HIDE_PRELOADER);
  }

  handleChange(field) {
    let _this = this;
    return function (event) {
      var state = {};
      state[field] = event.target.value;
      _this.setState(state);
    };
  }

  changeDataType(){

  }

  sendUpdatedProfile() {
    let user = IdentityAccessService.getUserProfile();
    user.firstName = this.state.firstName;
    user.lastName = this.state.lastName;
    IdentityAccessService.updateUser(user).then((status) => {
      this.publish(InternalEvent.App.SHOW_APP_MODAL, {type: "notify", header: status});
    });
  }

  render() {
    return (
      <ul className="center-object" ref="container">
        <li>
          <div>
            <h1 className="user-profile-title-text">
              <div className="h1-title-spacing">User Profile</div>
            </h1>
            <div className="layout-user-profile">
              <div className="box-1">
                <div className="space-box-150px-150px"></div>
              </div>
              <div className="box-2">
                <table>
                  <tbody>
                  <tr>
                    <td className="td-right-align-ls">
                      <div className="account-table-cell">First Name:</div>
                    </td>
                    <td className="td-left-align">
                      <div className="account-text-box">
                        <input type="text" value={this.state.firstName} onChange={this.handleChange("firstName")}/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-right-align-ls">
                      <div className="account-table-cell">Last Name:</div>
                    </td>
                    <td className="td-left-align">
                      <div className="account-text-box">
                        <input type="text" value={this.state.lastName} onChange={this.handleChange("lastName")}/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-right-align">
                      <div className="account-table-cell">User ID:</div>
                    </td>
                    <td className="td-left-align-s">
                      <div className="account-table-cell">
                        <div>{this.state.userEmail}</div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div className="box-3">
                <div className="space-box-150px-150px"></div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <h1 className="user-profile-title-text">
            <div className="h1-title-spacing-s">Account Settings</div>
          </h1>
          <div className="layout-user-profile">
            <div className="box-1">
              <div className="space-box-150px-90px"></div>
              <div className=""></div>
            </div>
            <div className="box-2">
              <table>
                <tbody>
                <tr>
                  <td className="td-right-align-s">
                    <div className="account-table-cell-s">Account Type:</div>
                  </td>
                  <td className="td-left-align">
                    <div>
                      <div ref="container">
                        <select className="size-of-account-type" id="account-type" value={accountType}
                                onChange={this.changeDataType}>
                          <option value="1" data-type="enum">Basic</option>
                          <option value="2" data-type="enum">Pro</option>
                          <option value="3" data-type="enum">Enterprise</option>
                        </select>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="box-3">
              <div className="space-box-150px-90px"></div>
            </div>
          </div>
        </li>
        <li>
          <div className="layout-user-profile">
            <div className="box-1">
              <div className="space-box-150px-70px"></div>
            </div>
            <div className="box-2">
              <table>
                <tbody>
                <tr>
                  <td className="td-right-align-s">
                  </td>
                  <td className="td-left-align">
                    <div className="account-table-cell">
                      <a className="waves-effect waves-light btn" onClick={this.sendUpdatedProfile}>Update</a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="box-3">
              <div className="space-box-150px-70px"></div>
            </div>
          </div>
        </li>
      </ul>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/account/accountSettings.jsx